import { ReactNode } from "react";

import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

import useUserRoles from "hooks/use-user-roles.hook";

import useLiveCallPrivacy from "./use-live-call-privacy.hook";

// The "Private" control on the workbench row (ENG-2364), for business owners
// and Suno only. Pressed while the call is hidden from the practice; the same
// row control as Hold / Keypad, so the host passes its renderer in.
export default function PrivateCallControl({
  sdkCallId,
  render
}: {
  sdkCallId: string;
  render: (props: {
    label: string;
    icon: ReactNode;
    pressed: boolean;
    onClick: () => void;
  }) => ReactNode;
}) {
  const { isSunoAdminOrBusinessOwner } = useUserRoles();
  const { isPrivate, toggle } = useLiveCallPrivacy(sdkCallId);
  if (!isSunoAdminOrBusinessOwner) return null;
  return (
    <>
      {render({
        label: "Private",
        icon: <VisibilityOffOutlinedIcon fontSize="small" />,
        pressed: isPrivate,
        onClick: toggle
      })}
    </>
  );
}
